import { ClaimReportGetUseCase } from '../../../application';

export default class ClaimReportGetService {
    constructor() {}

    async execute() {
        const request = await ClaimReportGetUseCase();

        return request;
    }
}
